import type { DashboardSnapshot } from "../../shared/contracts";

export interface TradingReadiness {
  ready: boolean;
  issues: string[];
}

function joinPermissions(permissions: string[]) {
  return permissions.join(", ");
}

export function getTradingReadiness(snapshot: DashboardSnapshot): TradingReadiness {
  const issues: string[] = [];
  const { connection, fees, market } = snapshot;

  if (!connection.connected) issues.push("Connect Kraken Pro.");
  if (!connection.privateKeyStored) issues.push("Confirm encrypted credential storage.");
  if (connection.missingPermissions.length > 0) {
    issues.push(`Grant required permissions: ${joinPermissions(connection.missingPermissions)}.`);
  }
  if (connection.forbiddenPermissions.length > 0) {
    issues.push(`Remove forbidden permissions: ${joinPermissions(connection.forbiddenPermissions)}.`);
  }
  if (fees.source !== "authenticated" || fees.makerPercent === null || fees.takerPercent === null) {
    issues.push("Refresh authenticated Kraken fees.");
  }
  if (market.stale || market.updatedAt === null) issues.push("Wait for fresh ETH/USD market data.");
  if (market.systemStatus.trim().toLowerCase() !== "online") {
    issues.push(`Kraken market status is ${market.systemStatus || "unavailable"}.`);
  }

  return { ready: issues.length === 0, issues };
}
